/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */
import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

// @mui material components
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import Icon from "@mui/material/Icon";
import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

// React-Select component and styling
import Select from "react-select";

//  config file
import Config from "../../../config/index";

// Functions from store
import {
  createActivityMapping,
  createDynamicColumn,
  deleteItems,
  editLocation,
  getAcn,
  getDynamicColumn,
  getItemMaster,
  getLevel1ByLevel,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  getLevelsByWarehouse,
  getMappedActivity,
  getOpenBinsByWarehouseAndZone,
  getRelationLocation,
  getSubModulesByRoleId,
  getWarehouses,
  getWarehousesByMovement,
  getZonesByWarehouse,
  uploadCsvForItemMapping,
} from "../../../store";

// Cookies
import { Backdrop } from "@mui/material";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";
import { addMinutes, format } from "date-fns";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "scroll",
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const ItemLocationMapping = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,

  createDynamicColumn,
  getWarehouses,
  deleteItems,
  warehouses,
  getMappedActivity,
  getMappedActivityReducer,
  getItemMaster,
  getDynamicColumn,
  itemMaster,
  getZonesByWarehouse,
  zonesByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getRelationLocationReducer,
  getLevel1ByLevel,
  getWarehouseByMovementReducer,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel1ByLevelReducer,
  getLevel2ByLevelReducer,
  getLevel3ByLevelReducer,
  getLevel4ByLevel,
  getLevel4ByLevelReducer,
  editLocation,
  getAcn,
  getAcnReducer,
  getRelationLocation,
  createActivityMapping,
  getWarehousesByMovement,
  uploadCsvForItemMapping,
  getLevelsByWarehouse,
  levelsByWarehouseReducer,

  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  const subModuleId = "87cf2280-5d20-43cc-b0e9-2e2b8b41ea4c";
  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "87cf2280-5d20-43cc-b0e9-2e2b8b41ea4c",
  );

  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
        "6124d229-7a16-4cbc-a50d-3754fc970055",
      )
    : null;

  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
        "283254a7-d0df-44cd-8065-c35bb7d6fd6f",
      )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
        "396cd7cf-6774-428a-bc07-1fec5aeb72ed",
      )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
        "13fbd62d-83bb-4e34-9503-b5a7a6a05f32",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  const [warehouseIdSelected, setWarehouseIdSelected] = useState("");
  const [zoneIdSelected, setZoneIdSelected] = useState("");
  const [sectionIdSelected, setSectionIdSelected] = useState("");
  const [rackIdSelected, setRackIdSelected] = useState("");
  const [locationIdSelected, setLocationIdSelected] = useState("");
  const [activityIdSelected, setActivityIdSelected] = useState("");

  const handleActivityIdChange = (selectedActivity) => {
    setActivityIdSelected(selectedActivity);
    setWarehouseIdSelected("");
  };

  const handleChangeWarehouse = (selectedData) => {
    setWarehouseIdSelected(selectedData);
    setZoneIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleZoneIDChange = (selectedRack) => {
    setZoneIdSelected(selectedRack);
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleSectionIdChange = (selectedRack) => {
    setSectionIdSelected(selectedRack);
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleRackIdChange = (selectedRack) => {
    setRackIdSelected(selectedRack);
    setLocationIdSelected("");
  };

  const handleLocationIdChange = (selectedLocation) => {
    setLocationIdSelected(selectedLocation);
  };

  useEffect(() => {
    getMappedActivity(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [pageNo, rowsPerPage, searchObject, refresh]);

  const [selectedZoneName, setSelectedZoneName] = useState("");

  const handleZoneNameChange = (selectedZoneName) => {
    setSelectedZoneName(selectedZoneName);
    setRackIdSelected("");
  };

  const [state, setState] = useState({
    columns: [
      { Header: "Item Code", accessor: "itemCode", align: "left" },
      {
        Header: "Item Description",
        accessor: "itemDescription",
        align: "left",
        width: 320,
      },

      { Header: "Category Code", accessor: "categoryCode" },
      { Header: "Warehouse", accessor: "warehouse" },
      { Header: "Zone", accessor: "zone" },
      { Header: "Section", accessor: "section" },
      { Header: "Rack", accessor: "rack" },
      { Header: "Location", accessor: "location" },
      { Header: "Acn Code", accessor: "acnCode" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },

      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [activityOptions, setActivityOptions] = useState([]);

  useEffect(() => {
    let tempActivityOptions = [];
    let data = getAcnReducer.acn.data ? getAcnReducer.acn.data : [];
    data.map((activity) => {
      tempActivityOptions.push({
        label: activity.acnName,
        value: activity.acnId,
      });
    });
    setActivityOptions(tempActivityOptions);
  }, [getAcnReducer]);

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = warehouses.warehouses ? warehouses.warehouses : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptions(tempWarehouseOptions);
  }, [warehouses]);

  const [warehouseOptionsByMovement, setWarehouseOptionsByMovement] = useState(
    [],
  );

  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = getWarehouseByMovementReducer.warehouses.data
      ? getWarehouseByMovementReducer.warehouses.data
      : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptionsByMovement(tempWarehouseOptions);
  }, [getWarehouseByMovementReducer]);
  // useEffect(() => {
  //   let tempLevelOptions = [];
  //   let data = getRelationLocationReducer.locations.data
  //     ? getRelationLocationReducer.locations.data
  //     : [];

  //   data.map((level) => {
  //     tempLevelOptions.push({
  //       label: level.rltName,
  //       value: level.rltLevel,
  //     });
  //   });
  //   setLevelOptions(tempLevelOptions);
  // }, [getRelationLocationReducer]);

  // let level1Name = getRelationLocationReducer.locations.data

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [zoneOptions, setZoneOptions] = useState([]);

  useEffect(() => {
    let tempZonesByWarehouse = [];
    let data = zonesByWarehouse.zones.data ? zonesByWarehouse.zones.data : [];
    data.map((zone) => {
      tempZonesByWarehouse.push({
        label: zone.zoneName,
        value: zone.id,
      });
    });
    setZoneOptions(tempZonesByWarehouse);
  }, [zonesByWarehouse]);

  // useEffect(() => {
  //   getLevelsByWarehouse(warehouseIdSelected?.value, jwtToken);
  // }, [warehouseIdSelected]);

  const [levelOptions, setLevelOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = levelsByWarehouseReducer.levelsByWarehouse.data
      ? levelsByWarehouseReducer.levelsByWarehouse.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level?.rltName,
        value: level?.rltLevel,
      });
    });
    setLevelOptions(tempLevelOptions);
  }, [levelsByWarehouseReducer]);

  const [level1Options, setLevel1Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel1ByLevelReducer.level1ByLevel.data
      ? getLevel1ByLevelReducer.level1ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel1Options(tempLevelOptions);
  }, [getLevel1ByLevelReducer]);

  const [level2Options, setLevel2Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel2ByLevelReducer.level2ByLevel.data
      ? getLevel2ByLevelReducer.level2ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel2Options(tempLevelOptions);
  }, [getLevel2ByLevelReducer]);

  const [level3Options, setLevel3Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel3ByLevelReducer.level3ByLevel.data
      ? getLevel3ByLevelReducer.level3ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel3Options(tempLevelOptions);
  }, [getLevel3ByLevelReducer]);

  const [level4Options, setLevel4Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel4ByLevelReducer.level4ByLevel.data
      ? getLevel4ByLevelReducer.level4ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel4Options(tempLevelOptions);
  }, [getLevel4ByLevelReducer]);

  const [openBinsOptions, setOpenBinsOptions] = useState([]);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempMappedActivity = [];
    let data = getMappedActivityReducer.mappedActivity.data
      ? getMappedActivityReducer.mappedActivity.data
      : [];
    setPaginationObj(getMappedActivityReducer?.mappedActivity?.pagination);
    setLoading(getMappedActivityReducer.loading);

    data.map((item) => {
      const formatDate = new Date(item.cd);
      let itemDescription = item.itemDescription;
      let len = desLength;

      const itemObject = {
        privateKey: item.itemCode,
        itemCodeDes: `${item.itemCode} / ${
          itemDescription ? itemDescription.substring(0, len) : ""
        }`,
        itemCode: item.itemCode,

        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {item?.itemDescription?.length > 35 ? (
              <Tooltip
                title={item.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {item.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {item.itemDescription}
              </MDTypography>
            )}
            {item?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),

        id: item.id,
        categoryCode: item.categoryCode,
        warehouse: item.warehouseCode,
        zone: item.zone,
        section: item.section,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: item.cd,
        rack: item.rack,
        location: item.location,
        // itemName: des ? des.substring(0, len) : "",
        acnCode: item.acnCode,
        action: (
          <>
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => {
                  handleOpenUpdateModal(item);
                }}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    viewAccess && setState({ ...state, rows: tempMappedActivity });
  }, [getMappedActivityReducer]);

  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);

  useEffect(() => {
    if (isSuccessAllocateItem) {
      setTimeout(() => {
        setIsSuccessAllocateItem(false);
      }, 3000);
    }
  }, [isSuccessAllocateItem]);

  useEffect(() => {
    if (isErrorAllocateItem) {
      setTimeout(() => {
        setIsErrorAllocateItem(false);
      }, 3000);
    }
  }, [isErrorAllocateItem]);

  const [allocateItemModal, setAllocateItemModal] = useState(false);
  const handleAllocateItemModal = () => {
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});
    setZoneIdSelected("");
    setWarehouseIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleCloseAllocateItemModal = () => {
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});
    setWarehouseIdSelected("");
    setLocationIdSelected("");
    setActivityIdSelected("");
    setSelectedItemCode("");
  };

  const [ActivityMappingData, setActivityMappingData] = useState({});

  const [selectedItemCode, setSelectedItemCode] = useState("");

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };

  const [selectedBin, setSelectedBin] = useState("");

  const handleBinChange = (selectedBin) => {
    setSelectedBin(selectedBin);
  };
  const [selectedBinForAdd, setSelectedBinForAdd] = useState("");

  const handleBinChangeForAdd = (selectedBinForAdd) => {
    setSelectedBinForAdd(selectedBinForAdd);
  };

  const [selectedOpenBin, setSelectedOpenBin] = useState(
    ActivityMappingData?.locationName,
  );

  useEffect(() => {
    if (ActivityMappingData) {
      setSelectedOpenBin({
        label: ActivityMappingData?.locationName,
        value: ActivityMappingData?.locationName,
      });
    }
  }, [ActivityMappingData]);

  const handleOpenBinChange = (selectedOpenBin) => {
    setSelectedOpenBin(selectedOpenBin);
  };

  const initialValues = {
    itemCode: "",
    acn: "",
    warehouseCode: "",
    level1: "",
    level2: "",
    level3: "",
    location: "",
    // rackName: "",
    // bin: "",
  };

  const validationSchema = Yup.object({
    itemCode: Yup.object().required("Select item Code"),
    acn: Yup.object().required("Select movement type"),
    warehouseCode: Yup.object().required("Select a warehouse"),
    // level1: Yup.object().required("Select a level"),
    // level2: Yup.object().required("Select a level"),
    // level3: Yup.object().required("Select a level"),
    // location: Yup.object().required("Select a location"),
  });

  const [errorMsg, setErrorMsg] = useState("");

  const [allocateButtonName, setAllocateButtonName] = useState("Allocate");

  const onSubmit = async (values, { resetForm }) => {
    setAllocateButtonName("Please wait...");
    const payload = {
      warehouseId: warehouseIdSelected?.value,
      itemId: selectedItemCode.value,
      zoneId: zoneIdSelected.value,
      sectionId: sectionIdSelected.value,
      rackId: rackIdSelected.value,
      locationId: locationIdSelected.value,
      acnId: activityIdSelected.value,
    };

    let res = await createActivityMapping(payload, jwtToken);
    if (res.status) {
      setIsSuccessAllocateItem(true);
      getOpenBinsByWarehouseAndZone(warehouseIdSelected?.value, zoneIdSelected);
      getMappedActivity(pageNo, rowsPerPage, searchObject, jwtToken);
      formik.setErrors({});
      setActivityIdSelected("");
      setWarehouseIdSelected("");
      setZoneIdSelected("");
      setSectionIdSelected("");
      setRackIdSelected("");
      setLocationIdSelected("");
      setTimeout(() => {
        setAllocateButtonName("Allocate");
        handleCloseAllocateItemModal();
      }, 2250);
    }
    if (!res.status) {
      setErrorMsg(res?.data?.data?.msg);
      setAllocateButtonName("Allocate");
      setIsErrorAllocateItem(true);
    }
    setSelectedItemCode("");
    setSelectedZoneName("");
    setSelectedBin("");
    resetForm();
  };

  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleOpenDeleteModal = (data) => {
    setOpenDeleteModal(true);
    setSingleDataForDelete(data);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  const [isErrorDeleteAssembly, setIsErrorDeleteAssembly] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState(false);
  const [isSuccessForAssembly, setIsSuccessForAssembly] = useState(false);

  useEffect(() => {
    if (isErrorDeleteAssembly) {
      setTimeout(() => {
        setIsErrorDeleteAssembly(false);
      }, 3000);
    }
  }, [isErrorDeleteAssembly]);
  useEffect(() => {
    if (isSuccessForAssembly) {
      setTimeout(() => {
        setIsSuccessForAssembly(false);
      }, 2000);
    }
  }, [isSuccessForAssembly]);

  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const deleteTripNo = async () => {
    setDeleteButtonName("Please wait...");
    let itemLocAcnMapId = singleDataForDelete.itemLocAcnMapId;
    // let userId = singleDataForDelete.userId;

    let res = await deleteItems(itemLocAcnMapId);

    if (res.status) {
      getMappedActivity(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 3000);
      setIsSuccessForAssembly(true);
    }

    if (!res.status) {
      setIsErrorDeleteAssembly(true);
      setErrorMsgForDelete(res?.data?.data?.msg);
      setDeleteButtonName("Delete");
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  const [isSuccessAddActivityMapping, setIsSuccessAddActivityMapping] =
    useState(false);
  const [isErrorAddActivityMapping, setIsErrorAddActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessAddActivityMapping) {
      setTimeout(() => {
        setIsSuccessAddActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessAddActivityMapping]);

  useEffect(() => {
    if (isErrorAddActivityMapping) {
      setTimeout(() => {
        setIsErrorAddActivityMapping(false);
      }, 3000);
    }
  }, [isErrorAddActivityMapping]);

  const [addActivityMappingModal, setAddActivityMappingModal] = useState(false);
  const handleAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };
  const handleCloseAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };

  const initialValueForAddActivityMapping = {
    bin: "",
  };

  const validationSchemaForAddActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForAddActivityMapping = async (values, { resetForm }) => {
    const payload = {
      warehouseId: warehouseIdSelected?.value,
      itemId: ActivityMappingData.itemId,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedBinForAdd.value,
    };

    setSelectedBinForAdd("");
    resetForm();
  };

  const formikForAdd = useFormik({
    initialValues: initialValueForAddActivityMapping,
    validationSchema: validationSchemaForAddActivityMapping,
    onSubmit: onSubmitForAddActivityMapping,
  });

  const [isSuccessEditActivityMapping, setIsSuccessEditActivityMapping] =
    useState(false);
  const [isErrorEditActivityMapping, setIsErrorEditActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessEditActivityMapping) {
      setTimeout(() => {
        setIsSuccessEditActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessEditActivityMapping]);

  useEffect(() => {
    if (isErrorEditActivityMapping) {
      setTimeout(() => {
        setIsErrorEditActivityMapping(false);
      }, 3000);
    }
  }, [isErrorEditActivityMapping]);

  const [editActivityMappingModal, setEditActivityMappingModal] =
    useState(false);
  const handleEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };

  const handleCloseEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };
  const initialValueForEditActivityMapping = {
    bin: "",
  };

  const validationSchemaForEditActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForEditActivityMapping = async (values, reset) => {
    const payload = {
      itemId: ActivityMappingData.itemId,
      warehouseId: warehouseIdSelected?.value,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedOpenBin?.value,
    };

    // let res = await editBinAllocation(payload, jwtToken);

    // if (res.status) {
    //   setIsSuccessEditActivityMapping(true);
    //   getMappedActivity(warehouseIdSelected?.value, jwtToken);
    // }
    // if (!res.status) {
    //   setIsErrorEditActivityMapping(true);
    // }
    // setSelectedOpenBin("");
  };
  const formikForEdit = useFormik({
    initialValues: initialValueForEditActivityMapping,
    validationSchema: validationSchemaForEditActivityMapping,
    onSubmit: onSubmitForEditActivityMapping,
    enableReinitialize: true,
  });

  const [warehouseTypesSelectedForEdit, setWarehouseTypesSelectedForEdit] =
    useState("");
  const [itemCodeSelectedForEdit, setItemCodeSelectedForEdit] = useState("");
  const [acnTypeSelectedForEdit, setAcnTypeSelectedForEdit] = useState("");
  const [zoneSelectedForEdit, setZoneSelectedForEdit] = useState("");
  const [sectionSelectedForEdit, setSectionSelectedForEdit] = useState("");
  const [rackSelectedForEdit, setRackSelectedForEdit] = useState("");
  const [locationSelectedForEdit, setLocationSelectedForEdit] = useState("");

  const [singleFgDataForUpdate, setSingleFgDataForUpdate] = useState({});
  const [openUpdateModal, setOpenUpdateModal] = useState(false);

  const handleOpenUpdateModal = (singleData) => {
    getWarehousesByMovement(singleData.acnId, jwtToken);
    // getZonesByWarehouse(singleData.zoneId, jwtToken);
    getLevel1ByLevel(singleData.warehouseId, 0, jwtToken);
    getLevel2ByLevel(singleData.warehouseId, singleData.zoneId, jwtToken);
    getLevel3ByLevel(singleData.warehouseId, singleData.sectionId, jwtToken);
    getLevel4ByLevel(singleData.warehouseId, singleData.rackId, jwtToken);
    setWarehouseTypesSelectedForEdit({
      label: singleData.warehouseCode,
      value: singleData.warehouseId,
    });
    setItemCodeSelectedForEdit({
      label: singleData.itemCode,
      value: singleData.itemId,
    });
    setAcnTypeSelectedForEdit({
      label: singleData.acnCode,
      value: singleData.acnId,
    });
    setZoneSelectedForEdit({
      label: singleData.zone,
      value: singleData.zoneId,
    });
    setSectionSelectedForEdit({
      label: singleData.section,
      value: singleData.sectionId,
    });
    setRackSelectedForEdit({
      label: singleData.rack,
      value: singleData.rackId,
    });
    setLocationSelectedForEdit({
      label: singleData.location,
      value: singleData.locationId,
    });
    setSingleFgDataForUpdate(singleData);
    setOpenUpdateModal(true);

    // getWarehousesByMovement(
    //   acnTypeSelectedForEdit?.value,

    //   jwtToken
    // );
  };

  const handleChangeWarehouseForEdit = (selectedOption) => {
    setWarehouseTypesSelectedForEdit(selectedOption);
    setZoneSelectedForEdit("");
  };
  const handleChangeAcnForEdit = (selectedOption) => {
    setAcnTypeSelectedForEdit(selectedOption);
  };
  const handleChangeZoneForEdit = (selectedOption) => {
    setZoneSelectedForEdit(selectedOption);
    setSectionSelectedForEdit("");
  };
  const handleChangeSectionForEdit = (selectedOption) => {
    setSectionSelectedForEdit(selectedOption);
    setRackSelectedForEdit("");
  };
  const handleChangeRackForEdit = (selectedOption) => {
    setRackSelectedForEdit(selectedOption);
    setLocationSelectedForEdit("");
  };
  const handleChangeLocationForEdit = (selectedOption) => {
    setLocationSelectedForEdit(selectedOption);
  };

  const initialValueForUpdate = {
    warehouseCode: "",
  };

  const handleCloseModal = () => {
    setOpenUpdateModal(false);
    formikForUpdate.setErrors({});
    formikForUpdate.setValues(initialValueForUpdate);
  };
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const [editButtonName, setEditButtonName] = useState("Submit");

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    let payload = {
      id: singleFgDataForUpdate.itemLocAcnMapId,
      itemId: itemCodeSelectedForEdit?.value,
      acnId: singleFgDataForUpdate.acnId,
      mvtId: acnTypeSelectedForEdit?.value,
      warehouseId: warehouseTypesSelectedForEdit?.value,
      zoneId: zoneSelectedForEdit?.value,
      sectionId: sectionSelectedForEdit?.value,
      rackId: rackSelectedForEdit?.value,
      locationId: locationSelectedForEdit ? locationSelectedForEdit?.value : 0,
    };
    let res = await editLocation(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getMappedActivity(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseModal();
        setEditButtonName("Submit");
      }, 3000);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
      setEditButtonName("Submit");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForAssembly,
    enableReinitialize: true,
  });
  const [isErrorDeleteActivityMapping, setIsErrorDeleteActivityMapping] =
    useState(false);
  useEffect(() => {
    if (isErrorDeleteActivityMapping) {
      setTimeout(() => {
        setIsErrorDeleteActivityMapping(false);
      }, 3000);
    }
  }, [isErrorDeleteActivityMapping]);

  const [openDeleteActivityMappingModal, setOpenDeleteActivityMappingModal] =
    useState(false);

  const handleOpenDeleteActivityMappingModal = (data = {}) => {
    setActivityMappingData(data);
    setOpenDeleteActivityMappingModal(true);
  };

  const handleCloseDeleteActivityMappingModal = () => {
    setOpenDeleteActivityMappingModal(false);
  };

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");
  // const [editButtonName, setEditButtonName] = useState("Submit");

  const onClickDeleteActivityMapping = async () => {
    // let res = await removeBinAllocation(
    //   warehouseIdSelected?.value,
    //   ActivityMappingData.itemId,
    //   ActivityMappingData.zoneId,
    //   ActivityMappingData.locationId,
    //   jwtToken
    // );
    // if (res.status) {
    //   getMappedActivity(warehouseIdSelected?.value, jwtToken);
    //   setOpenDeleteActivityMappingModal(false);
    // }
    // if (!res.status) {
    //   setDeleteErrorMsg(res.data.response.data.msg);
    //   setIsErrorDeleteActivityMapping(true);
    // }
  };

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);
  const data = getRelationLocationReducer.locations?.data || [];
  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };
  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    let data = new FormData();

    data.append("item_mapping", uploadCsvData);

    // let res = await uploadCsvForItemMapping(data);

    // if (res.status) {
    //   getMappedActivity(jwtToken);
    //   setUploadCsvFilter(false);
    //   DataUploadSuccessNotification();
    // }

    // if (!res.status) {
    //   DataUploadFailureNotification(res?.data?.data?.msg);
    // }
  };

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getMappedActivity(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    // <DashboardLayout>
    //   <DashboardNavbar />
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={0}
              mb={-4.5}
              mt={-1}
            >
              <MDBox color="text" px={2} ml={-2} mb={4}>
                {allocateAccess && (
                  <Tooltip>
                    <CreateButton
                      tooltip="Allocate Location"
                      color="info"
                      variant="contained"
                      type="button"
                      iconOnly
                      onClick={(event) => {
                        handleAllocateItemModal();
                        getWarehouses(jwtToken);
                        getItemMaster(jwtToken);
                        getAcn(jwtToken);
                        getRelationLocation(jwtToken);
                      }}
                      style={{ borderRadius: "5px" }}
                      size="small"
                    >
                      <Icon>add</Icon>
                    </CreateButton>
                  </Tooltip>
                )}
                {/* <Tooltip title="Upload CSV">
                    <MDButton
                      style={{ marginLeft: "1rem" }}
                      // disabled={!uploadItem}
                      type="button"
                      variant="outlined"
                      color="info"
                      iconOnly
                      onClick={uploadCsvFilterHandler}
                    >
                      <Icon>upload</Icon>
                    </MDButton>
                  </Tooltip> */}
              </MDBox>
            </MDBox>

            {uploadCsvFilter && (
              <div style={{ marginLeft: "1", marginTop: "0.5rem" }}>
                <div>
                  <input
                    className="choose_file"
                    style={{
                      marginTop: "1.5rem",
                      marginLeft: "1.5rem",
                      // marginBottom: "-9rem",
                    }}
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      setUploadCsvData(e.target.files[0]);
                    }}
                  />
                  <MDButton
                    disabled={
                      !uploadCsvData?.name || uploadCsvData?.type !== "text/csv"
                    }
                    variant="contained"
                    color="info"
                    style={{
                      marginLeft: { xs: "1.5rem", lg: "1" },
                      marginTop: "0rem",
                    }}
                    type="button"
                    onClick={uploadCsvHandler}
                  >
                    UPLOAD
                  </MDButton>
                </div>
                <div style={{ marginBottom: "-20px" }}>
                  <span
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginLeft: "30px",
                      fontStyle: "italic",
                    }}
                  >
                    <strong>*</strong> Please upload
                    <strong>".csv"</strong> file only
                  </span>
                </div>
              </div>
            )}
            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    // onClick={handleDynamicColumn}
                    // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            <MDBox pt={0}>
              {loadingForDynamicColumn && (
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  options={{ draggable: false }}
                  serverSidePagination={true}
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                  loading={loading}
                  hideColumns={hiddenColumsDetails}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                />
              )}
            </MDBox>
            <Modal
              open={openDeleteModal}
              onClose={handleCloseDeleteModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ marginLeft: "0.5rem" }}
                    color="error"
                    onClick={deleteTripNo}
                    disabled={deleteButtonName === "Please wait..."}
                  >
                    {deleteButtonName}
                  </MDButton>
                  <MDBox mt={2}>
                    <Collapse in={isErrorDeleteAssembly}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorDeleteAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForDelete}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessForAssembly}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessForAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Deleted Successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openUpdateModal}
              onClose={handleCloseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForEdit}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox>
                      <Grid container spacing={1}>
                        <Grid item xs={12} lg={4}>
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Item Code
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={180}
                              placeholder="Select..."
                              isDisabled={true}
                              name="itemCode"
                              options={itemCodeOptions}
                              value={itemCodeSelectedForEdit} // Ensure this matches the shape of options
                              // onChange={(selectedOption) => {
                              //   handleChangeWarehouseForsEdits(selectedOption);
                              //   formikForUpdate.setFieldValue(
                              //     "assemblyType",
                              //     selectedOption
                              //   );
                              // }}
                            />
                            {formikForUpdate.touched.itemCode &&
                              formikForUpdate.errors.itemCode && (
                                <TextError
                                  msg={formikForUpdate.errors.itemCode}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              ACN Code
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={130}
                              placeholder="Select..."
                              isDisabled={true}
                              name="acn"
                              options={activityOptions}
                              value={acnTypeSelectedForEdit} // Ensure this matches the shape of options
                              onChange={(selectedOption) => {
                                handleChangeAcnForEdit(selectedOption);
                                formikForUpdate.setFieldValue(
                                  "acn",
                                  selectedOption,
                                );
                              }}
                            />
                            {formikForUpdate.touched.itemCode &&
                              formikForUpdate.errors.itemCode && (
                                <TextError
                                  msg={formikForUpdate.errors.itemCode}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              WarehouseCode
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={130}
                              placeholder="Select..."
                              name="warehouseCode"
                              options={warehouseOptionsByMovement}
                              value={warehouseTypesSelectedForEdit} // Ensure this matches the shape of options
                              onChange={(selectedOption) => {
                                handleChangeWarehouseForEdit(selectedOption);
                                getZonesByWarehouse(selectedOption?.value);

                                formikForUpdate.setFieldValue(
                                  "warehouseCode",
                                  selectedOption,
                                );
                                getLevel1ByLevel(
                                  selectedOption?.value,
                                  0,
                                  jwtToken,
                                );
                              }}
                            />
                            {formikForUpdate.touched.warehouseCode &&
                              formikForUpdate.errors.warehouseCode && (
                                <TextError
                                  msg={formikForUpdate.errors.warehouseCode}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Zone
                            </MDTypography>
                            <Select
                              isClearable
                              isDisabled={
                                warehouseTypesSelectedForEdit ? false : true
                              }
                              className="select-css"
                              maxMenuHeight={70}
                              placeholder="Select..."
                              name="zone"
                              options={level1Options}
                              value={zoneSelectedForEdit} // Ensure this matches the shape of options
                              onChange={(selectedOption) => {
                                handleChangeZoneForEdit(selectedOption);
                                formikForUpdate.setFieldValue(
                                  "zone",
                                  selectedOption,
                                );
                                getLevel2ByLevel(
                                  warehouseTypesSelectedForEdit?.value,
                                  selectedOption?.value,
                                  jwtToken,
                                );
                              }}
                            />
                            {formikForUpdate.touched.zone &&
                              formikForUpdate.errors.zone && (
                                <TextError msg={formikForUpdate.errors.zone} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Section
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={70}
                              placeholder="Select..."
                              name="section"
                              options={level2Options}
                              value={sectionSelectedForEdit} // Ensure this matches the shape of options
                              onChange={(selectedOption) => {
                                handleChangeSectionForEdit(selectedOption);
                                formikForUpdate.setFieldValue(
                                  "section",
                                  selectedOption,
                                );
                                getLevel3ByLevel(
                                  warehouseTypesSelectedForEdit?.value,
                                  selectedOption?.value,
                                  jwtToken,
                                );
                              }}
                            />
                            {formikForUpdate.touched.section &&
                              formikForUpdate.errors.section && (
                                <TextError
                                  msg={formikForUpdate.errors.section}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={3}>
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Rack
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={70}
                              placeholder="Select..."
                              name="rack"
                              options={level3Options}
                              value={rackSelectedForEdit} // Ensure this matches the shape of options
                              onChange={(selectedOption) => {
                                handleChangeRackForEdit(selectedOption);
                                formikForUpdate.setFieldValue(
                                  "rack",
                                  selectedOption,
                                );
                                getLevel4ByLevel(
                                  warehouseTypesSelectedForEdit?.value,
                                  selectedOption?.value,
                                  jwtToken,
                                );
                              }}
                            />
                            {formikForUpdate.touched.rack &&
                              formikForUpdate.errors.rack && (
                                <TextError msg={formikForUpdate.errors.rack} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={3}>
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Location
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={70}
                              placeholder="Select..."
                              name="location"
                              options={level4Options}
                              value={locationSelectedForEdit} // Ensure this matches the shape of options
                              onChange={(selectedOption) => {
                                handleChangeLocationForEdit(selectedOption);
                                formikForUpdate.setFieldValue(
                                  "location",
                                  selectedOption,
                                );
                              }}
                            />
                            {formikForUpdate.touched.location &&
                              formikForUpdate.errors.location && (
                                <TextError
                                  msg={formikForUpdate.errors.location}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <MDBox>
                          <Collapse in={isErrorForUpdate}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorForUpdate(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgForUpdate}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessForUpdate}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsSuccessForUpdate(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Updated successfully
                            </Alert>
                          </Collapse>
                        </MDBox>
                        {/* <MDBox mt={3} ml={10}> */}
                        <MDButton
                          // variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton>
                        {/* </MDBox> */}
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={allocateItemModal}
              onClose={handleCloseAllocateItemModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Allocate
                  </MDTypography>
                  <MDBox>
                    <span>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseAllocateItemModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <Grid container>
                      <Grid item xs={12} lg={6}>
                        <MDBox ml={-0.8}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Item Code/Des
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={280}
                            placeholder="Choose one..."
                            name="itemCode"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "itemCode" },
                              });
                            }}
                            value={selectedItemCode}
                            options={itemCodeOptions}
                            onChange={(selectedOption) => {
                              handleItemCodeChange(selectedOption);
                              formik.setFieldValue("itemCode", selectedOption);
                            }}
                          />

                          {formik.touched.itemCode &&
                            formik.errors.itemCode && (
                              <TextError msg={formik.errors.itemCode} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={{ xs: 0, lg: 1 }}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Movement{" "}
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={300}
                            placeholder="Choose one..."
                            name="acn"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "acn" },
                              });
                            }}
                            value={activityIdSelected}
                            options={activityOptions}
                            onChange={(selectedOption) => {
                              handleActivityIdChange(selectedOption);
                              formik.setFieldValue("acn", selectedOption);
                              getWarehousesByMovement(
                                selectedOption?.value,

                                jwtToken,
                              );
                            }}
                          />
                          {formik.touched.acn && formik.errors.acn && (
                            <TextError msg={formik.errors.acn} />
                          )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Warehouse Code{" "}
                          </MDTypography>

                          <Select
                            isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="warehouseCode"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "warehouseCode" },
                              });
                            }}
                            value={warehouseIdSelected}
                            options={warehouseOptionsByMovement}
                            onChange={(selectedOption) => {
                              handleChangeWarehouse(selectedOption);
                              getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue(
                                "warehouseCode",
                                selectedOption,
                              );
                              getLevel1ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken,
                              );
                              getLevel2ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken,
                              );
                              getLevel3ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken,
                              );
                              getLevel4ByLevel(
                                selectedOption?.value,
                                0,
                                jwtToken,
                              );
                            }}
                          />
                          {formik.touched.warehouseCode &&
                            formik.errors.warehouseCode && (
                              <TextError msg={formik.errors.warehouseCode} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox ml={{ xs: 0, lg: 1 }}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Level 1:-
                            {data.length > 0
                              ? data[0].rltName
                              : "No data available"}
                          </MDTypography>

                          <Select
                            isClearable
                            isDisabled={
                              (warehouseIdSelected ? false : true) ||
                              levelOptions[0]?.value !== 1
                            }
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="level1"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "level1" },
                              });
                            }}
                            value={zoneIdSelected}
                            options={level1Options}
                            onChange={(selectedOption) => {
                              handleZoneIDChange(selectedOption);
                              formik.setFieldValue("level1", selectedOption);
                              getLevel2ByLevel(
                                warehouseIdSelected?.value,
                                selectedOption?.value,
                                jwtToken,
                              );
                              getLevel3ByLevel(
                                warehouseIdSelected?.value,
                                selectedOption?.value,
                                jwtToken,
                              );
                              getLevel4ByLevel(
                                warehouseIdSelected?.value,
                                selectedOption?.value,
                                jwtToken,
                              );
                            }}
                          />
                          {formik.touched.level1 && formik.errors.level1 && (
                            <TextError msg={formik.errors.level1} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1}>
                          <MDTypography variant="h6">
                            {" "}
                            Level 2:-
                            {data.length > 0
                              ? data[1].rltName
                              : "No data available"}
                          </MDTypography>

                          <Select
                            isClearable
                            isDisabled={
                              levelOptions[0]?.value == 1 && !zoneIdSelected
                                ? true
                                : false ||
                                  !(
                                    levelOptions[0]?.value === 2 ||
                                    levelOptions[1]?.value === 2
                                  )
                            }
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="level2"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "level2" },
                              });
                            }}
                            value={sectionIdSelected}
                            options={level2Options}
                            onChange={(selectedOption) => {
                              handleSectionIdChange(selectedOption);
                              formik.setFieldValue("level2", selectedOption);
                              getLevel3ByLevel(
                                warehouseIdSelected?.value,
                                selectedOption?.value,
                                jwtToken,
                              );
                              getLevel4ByLevel(
                                warehouseIdSelected?.value,
                                selectedOption?.value,
                                jwtToken,
                              );
                            }}
                          />
                          {formik.touched.level2 && formik.errors.level2 && (
                            <TextError msg={formik.errors.level2} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox ml={{ xs: 0, lg: 1 }}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            Level 3:-
                            {data.length > 0
                              ? data[2].rltName
                              : "No data available"}
                          </MDTypography>

                          <Select
                            isClearable
                            isDisabled={
                              ((levelOptions[0]?.value == 2 ||
                                levelOptions[1]?.value == 2) &&
                              !sectionIdSelected
                                ? true
                                : false) ||
                              !(
                                levelOptions[0]?.value === 3 ||
                                levelOptions[1]?.value === 3 ||
                                levelOptions[2]?.value === 3
                              )
                            }
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose One..."
                            name="level3"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "level3" },
                              });
                            }}
                            value={rackIdSelected}
                            options={level3Options}
                            onChange={(selectedOption) => {
                              handleRackIdChange(selectedOption);
                              formik.setFieldValue("level3", selectedOption);
                              getLevel4ByLevel(
                                warehouseIdSelected?.value,
                                selectedOption?.value,
                                jwtToken,
                              );
                            }}
                          />
                          {formik.touched.level3 && formik.errors.level3 && (
                            <TextError msg={formik.errors.level3} />
                          )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1}>
                          <MDTypography variant="h6">
                            {data.length > 0
                              ? data[3].rltName
                              : "No data available"}
                          </MDTypography>

                          <Select
                            isClearable
                            isDisabled={
                              ((levelOptions[0]?.value == 3 ||
                                levelOptions[1]?.value == 3 ||
                                levelOptions[2]?.value == 3) &&
                              !rackIdSelected
                                ? true
                                : false) ||
                              !(
                                levelOptions[0]?.value === 4 ||
                                levelOptions[1]?.value === 4 ||
                                levelOptions[2]?.value === 4 ||
                                levelOptions[3]?.value === 4
                              )
                            }
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="location"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "location" },
                              });
                            }}
                            value={locationIdSelected}
                            options={level4Options}
                            onChange={(selectedOption) => {
                              handleLocationIdChange(selectedOption);
                              formik.setFieldValue("location", selectedOption);
                            }}
                          />
                          {formik.touched.location &&
                            formik.errors.location && (
                              <TextError msg={formik.errors.location} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12}>
                        <Collapse in={isErrorAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Location Allocated successfully
                          </Alert>
                        </Collapse>
                      </Grid>

                      <Grid item xs={12}>
                        <MDBox mt={1}>
                          <MDButton
                            color="info"
                            fullWidth
                            type="submit"
                            disabled={
                              !formik.isValid ||
                              selectedItemCode == "" ||
                              activityIdSelected == "" ||
                              (levelOptions[0]?.value === 1 &&
                                !zoneIdSelected) ||
                              (levelOptions[0]?.value === 2 &&
                                !sectionIdSelected) ||
                              (levelOptions[0]?.value === 3 &&
                                !rackIdSelected) ||
                              (levelOptions[0]?.value === 4 &&
                                !locationIdSelected) ||
                              allocateButtonName === "Please wait..."
                            }
                          >
                            {allocateButtonName}
                          </MDButton>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                    // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {/* <Footer /> */}
    </div>
    // </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    warehouses: state.warehouses,
    getMappedActivityReducer: state.getMappedActivityReducer,
    itemMaster: state.itemMaster,
    zonesByWarehouse: state.zonesByWarehouse,
    getLevel1ByLevelReducer: state.getLevel1ByLevelReducer,
    getLevel2ByLevelReducer: state.getLevel2ByLevelReducer,
    getLevel3ByLevelReducer: state.getLevel3ByLevelReducer,
    getLevel4ByLevelReducer: state.getLevel4ByLevelReducer,
    getAcnReducer: state.getAcnReducer,
    openBinsByWarehouse: state.openBinsByWarehouse,
    getRelationLocationReducer: state.getRelationLocationReducer,
    getWarehouseByMovementReducer: state.getWarehouseByMovementReducer,
    levelsByWarehouseReducer: state.levelsByWarehouseReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getWarehouses: (jwtToken) => dispatch(getWarehouses(jwtToken)),
    getMappedActivity: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(getMappedActivity(pageNo, rowsPerPage, searchObject, jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getZonesByWarehouse: (id, jwtToken) =>
      dispatch(getZonesByWarehouse(id, jwtToken)),
    getLevel1ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel1ByLevel(warehouseId, parentId, jwtToken)),
    getLevel2ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel2ByLevel(warehouseId, parentId, jwtToken)),
    getLevel3ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel3ByLevel(warehouseId, parentId, jwtToken)),
    getLevel4ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel4ByLevel(warehouseId, parentId, jwtToken)),
    getAcn: (jwtToken) => dispatch(getAcn(jwtToken)),
    getOpenBinsByWarehouseAndZone: (id, zoneId, jwtToken) =>
      dispatch(getOpenBinsByWarehouseAndZone(id, zoneId, jwtToken)),
    createActivityMapping: (payload, jwtToken) =>
      dispatch(createActivityMapping(payload, jwtToken)),
    deleteItems: (itemLocAcnMapId, jwtToken) =>
      dispatch(deleteItems(itemLocAcnMapId, jwtToken)),
    uploadCsvForItemMapping: (payload, jwtToken) =>
      dispatch(uploadCsvForItemMapping(payload, jwtToken)),
    getRelationLocation: (jwtToken) => dispatch(getRelationLocation(jwtToken)),
    getWarehousesByMovement: (activityIdSelected, jwtToken) =>
      dispatch(getWarehousesByMovement(activityIdSelected, jwtToken)),
    editLocation: (payload, jwtToken) =>
      dispatch(editLocation(payload, jwtToken)),
    getLevelsByWarehouse: (warehouseId, jwtToken) =>
      dispatch(getLevelsByWarehouse(warehouseId, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItemLocationMapping);
